import axios from "axios";
import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import AlertComponent from "../../components/AlertComponent";

export default function EsqueciSenha() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${process.env.REACT_APP_API}/auth/reset-senha`, { email });

      AlertComponent(
        "Sucesso",
        "Se este e-mail existir, enviaremos um link para redefinir a senha.",
        { icon: "success" }
      );

      // opcional: volta pro login
      navigate("/login");
    } catch (error) {
      const mensagem = error?.response?.data?.message || error?.message || "Erro desconhecido";
      AlertComponent("Erro", mensagem, { icon: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="w-full max-w-md bg-white rounded-xl shadow-lg p-8">
        <h1 className="text-2xl font-semibold text-center text-gray-800 mb-2">
          Esqueci minha senha
        </h1>
        <p className="text-sm text-center text-gray-500 mb-8">
          Informe seu e-mail para receber o link de redefinição.
        </p>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              E-mail
            </label>
            <input
              type="email"
              placeholder="seu@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm
                         focus:outline-none focus:ring-2 focus:ring-slate-600"
              required
              disabled={loading}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-slate-900 hover:bg-slate-800 disabled:opacity-60 text-white py-2.5 rounded-md font-medium transition"
          >
            {loading ? "Enviando..." : "Enviar link"}
          </button>
        </form>

        <div className="mt-6 flex justify-between items-center text-sm">
          <Link to="/login" className="text-slate-600 hover:text-slate-900 hover:underline">
            Voltar para login
          </Link>
        </div>

        <div className="mt-8 text-center text-xs text-gray-400">
          © {new Date().getFullYear()} Quality Digital
        </div>
      </div>
    </div>
  );
}